import React, { useState, useEffect, useMemo } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Divider,
  Stack,
  TextField,
  styled,
} from "@mui/material";
import { Grid, Typography } from "@mui/material";
import {
  BodyContainer,
  ButtonAdd,
  Header,
  TopGrid,
} from "../../components/styles";
import Loader from "../../components/components/Loader";
import AddPhoto from "../../images/add_a_photo.png";

import BackIcon from "../../images/undo.svg";
import Search from "../../components/components/Search";
import { ImgBox, OrderBox, SubTitle, Title } from "./style";
import moment from "moment";
import { Link, useLocation } from "react-router-dom";

function ManageItems() {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [modal, setModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState("");
  const [idx, setIdx] = useState(null);
  const [image, setImage] = useState("");
  const [imgPreview, setImgPreview] = useState(null);

  const handleSearch = (e) => {
    const { value } = e.target;
    setSearchText(value);
  };

  const toggle = (item = "", index = null) => {
    setModal((prev) => !prev);
    setSelectedItem(item);
    setIdx(index);
  };

  const filteredItems = useMemo(() => {
    try {
      let arr = location?.state || [];
      if (searchText) {
        let filtered = arr.filter((i) =>
          i?.name?.toString().toLowerCase().startsWith(searchText.toLowerCase())
        );
        return filtered;
      } else {
        return arr;
      }
    } catch (err) {
      console.log("err:", err);
    }
  }, [searchText]);

  const handleImage = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImgPreview(reader.result);
      };

      reader.readAsDataURL(file);
    } else {
      setImage(null);
      setImgPreview(null);
    }
  };

  const handleSubmit = () => {};

  return (
    <Box sx={{ mt: 5 }}>
      <Header sx={{ mt: { md: "0px", xs: "40px" } }}>
        <TopGrid container alignItems="center" spacing={1}>
          <Grid item md={3} xs={12}>
            <Search
              name={"searchKey"}
              text={"Search item..."}
              value={searchText}
              onChange={handleSearch}
              //   onKeyDown={handleEnter}
              //   onClick={handleClick}
            />
          </Grid>
          <Grid align="center" item md={8} xs={12}>
            <Typography
              variant="h5"
              sx={{ color: "white", fontSize: { md: "1.5rem", xs: "16px" } }}
            >
              Manage Items
            </Typography>
          </Grid>
          <Grid item md={1} xs={12}>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Link to="/inventory/admin/store">
                <ButtonAdd
                  variant="contained"
                  sx={{ textTransform: "none", ml: 0 }}
                >
                  <img src={BackIcon} style={{ marginRight: "8px" }} /> Back
                </ButtonAdd>
              </Link>
            </Box>
          </Grid>
        </TopGrid>
      </Header>
      <BodyContainer sx={{ mt: { md: "100px", sm: "160px", xs: "220px" } }}>
        {filteredItems &&
          filteredItems?.map((item, i) => {
            return (
              <Box
                key={i}
                // onClick={() => toggle(item, i)}
              >
                <OrderBox sx={{ cursor: "pointer", mb: "8px" }}>
                  <Stack direction="row" alignItems="center" spacing="16px">
                    {item?.imgURL ? (
                      <img
                        height="70px"
                        width="70px"
                        src={item.imgURL}
                        alt=""
                      />
                    ) : (
                      <ImgBox>
                        <img src={AddPhoto} alt="" />
                      </ImgBox>
                    )}
                    <Title sx={{ fontSize: "18px" }}> {item?.name}</Title>

                    {/* <SubTitle>{item?.name}</SubTitle>
                <SubTitle>Quantity No</SubTitle> */}
                    {/* </Stack> */}
                  </Stack>
                  <Title sx={{ fontSize: "18px" }}>Rs {item?.price}</Title>
                </OrderBox>
              </Box>
            );
          })}

        {loading && <Loader loading={true} />}
      </BodyContainer>

      {modal && (
        <Dialog open={true} onClose={toggle} fullWidth maxWidth="xs">
          <DialogContent>
            <Stack spacing="24px">
              <Typography variant="h6" sx={{ textAlign: "center" }}>
                {selectedItem?.name}
              </Typography>
              <Stack spacing="8px" alignItems="center">
                {imgPreview && (
                  <img
                    style={{ maxHeight: "300px" }}
                    src={imgPreview}
                    alt="Selected"
                  />
                )}
                <Box>
                  <Typography>
                    {imgPreview ? "Replace" : "Upload"} Image
                  </Typography>
                  <TextField
                    size="small"
                    variant="outlined"
                    type="file"
                    onChange={handleImage}
                  />
                </Box>
              </Stack>

              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Button
                  variant="contained"
                  size="small"
                  sx={{ background: "#999999 !important" }}
                >
                  Cancel
                </Button>
                <Button variant="contained" size="small" onClick={handleSubmit}>
                  Upload
                </Button>
              </Box>
            </Stack>
          </DialogContent>
        </Dialog>
      )}
    </Box>
  );
}

export default ManageItems;
